import React, { forwardRef, InputHTMLAttributes } from 'react';
import { IconKey } from './Icon';
import BaseInput from './BaseInput';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    iconKey?: IconKey;
    type?: 'text' | 'number' | 'password' | 'email';
    defaultValue?: string;
}

const InputField = forwardRef<HTMLInputElement, Props>(
    (
        {
            id,
            label = null,
            className = '',
            type = 'text',
            iconKey,
            defaultValue,
            ...props
        },
        ref,
    ) => (
        <BaseInput
            id={id}
            ref={ref}
            label={label}
            className={className}
            type={type}
            iconKey={iconKey}
            defaultValue={defaultValue}
            {...props}
        />
    ),
);

export default InputField;
